/**
 * @generated SignedSource<<697d92876f89b7da5ddf856effde5a70>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type OrderDirection = 'ASC' | 'DESC' | '%future added value';
export type ProfileOrderField = 'CREATED_AT' | '%future added value';
export type ProfileOrder = {
  direction: OrderDirection;
  field?: ProfileOrderField | null;
};
export type ProfileQueriesGetProfileCrewPoolProfilesQuery$variables = {
  after?: any | null;
  before?: any | null;
  first?: number | null;
  last?: number | null;
  orderBy?: ProfileOrder | null;
  poolId: string;
};
export type ProfileQueriesGetProfileCrewPoolProfilesQuery$data = {
  readonly crewPoolProfiles: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly certificateInfos: ReadonlyArray<{
          readonly certificate: {
            readonly id: string;
          };
        }> | null;
        readonly generalSetting: {
          readonly availableForWork: boolean;
        } | null;
        readonly id: string;
        readonly info: {
          readonly avatarUrl: string | null;
          readonly birthDate: String;
          readonly country: {
            readonly isoCode: string;
          };
          readonly firstName: string;
          readonly id: string;
          readonly lastName: string;
          readonly primaryDuty: {
            readonly id: string;
          } | null;
        } | null;
        readonly seaServices: ReadonlyArray<{
          readonly activities: ReadonlyArray<{
            readonly id: string;
          }> | null;
          readonly duty: {
            readonly id: string;
          };
          readonly end: String | null;
          readonly id: string;
          readonly start: String;
        }> | null;
      } | null;
    } | null> | null;
    readonly totalCount: number;
  } | null;
};
export type ProfileQueriesGetProfileCrewPoolProfilesQuery = {
  response: ProfileQueriesGetProfileCrewPoolProfilesQuery$data;
  variables: ProfileQueriesGetProfileCrewPoolProfilesQuery$variables;
};

const node: ConcreteRequest = (function () {
  var v0 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'after',
    },
    v1 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'before',
    },
    v2 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'first',
    },
    v3 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'last',
    },
    v4 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'orderBy',
    },
    v5 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'poolId',
    },
    v6 = {
      kind: 'Variable',
      name: 'orderBy',
      variableName: 'orderBy',
    },
    v7 = {
      kind: 'Variable',
      name: 'poolId',
      variableName: 'poolId',
    },
    v8 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'totalCount',
      storageKey: null,
    },
    v9 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'id',
      storageKey: null,
    },
    v10 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'availableForWork',
      storageKey: null,
    },
    v11 = [v9 /*: any*/],
    v12 = {
      alias: null,
      args: null,
      concreteType: 'Duty',
      kind: 'LinkedField',
      name: 'primaryDuty',
      plural: false,
      selections: v11 /*: any*/,
      storageKey: null,
    },
    v13 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'firstName',
      storageKey: null,
    },
    v14 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'lastName',
      storageKey: null,
    },
    v15 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'birthDate',
      storageKey: null,
    },
    v16 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'isoCode',
      storageKey: null,
    },
    v17 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'avatarUrl',
      storageKey: null,
    },
    v18 = {
      alias: null,
      args: null,
      concreteType: 'Certificate',
      kind: 'LinkedField',
      name: 'certificate',
      plural: false,
      selections: v11 /*: any*/,
      storageKey: null,
    },
    v19 = {
      alias: null,
      args: null,
      concreteType: 'SeaService',
      kind: 'LinkedField',
      name: 'seaServices',
      plural: true,
      selections: [
        v9 /*: any*/,
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'start',
          storageKey: null,
        },
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'end',
          storageKey: null,
        },
        {
          alias: null,
          args: null,
          concreteType: 'Duty',
          kind: 'LinkedField',
          name: 'duty',
          plural: false,
          selections: v11 /*: any*/,
          storageKey: null,
        },
        {
          alias: null,
          args: null,
          concreteType: 'Activity',
          kind: 'LinkedField',
          name: 'activities',
          plural: true,
          selections: v11 /*: any*/,
          storageKey: null,
        },
      ],
      storageKey: null,
    },
    v20 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: '__typename',
      storageKey: null,
    },
    v21 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'cursor',
      storageKey: null,
    },
    v22 = {
      alias: null,
      args: null,
      concreteType: 'PageInfo',
      kind: 'LinkedField',
      name: 'pageInfo',
      plural: false,
      selections: [
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'endCursor',
          storageKey: null,
        },
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'hasNextPage',
          storageKey: null,
        },
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'hasPreviousPage',
          storageKey: null,
        },
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'startCursor',
          storageKey: null,
        },
      ],
      storageKey: null,
    },
    v23 = [
      {
        kind: 'Variable',
        name: 'after',
        variableName: 'after',
      },
      {
        kind: 'Variable',
        name: 'before',
        variableName: 'before',
      },
      {
        kind: 'Variable',
        name: 'first',
        variableName: 'first',
      },
      {
        kind: 'Variable',
        name: 'last',
        variableName: 'last',
      },
      v6 /*: any*/,
      v7 /*: any*/,
    ];
  return {
    fragment: {
      argumentDefinitions: [v0 /*: any*/, v1 /*: any*/, v2 /*: any*/, v3 /*: any*/, v4 /*: any*/, v5 /*: any*/],
      kind: 'Fragment',
      metadata: null,
      name: 'ProfileQueriesGetProfileCrewPoolProfilesQuery',
      selections: [
        {
          alias: 'crewPoolProfiles',
          args: [v6 /*: any*/, v7 /*: any*/],
          concreteType: 'ProfileConnection',
          kind: 'LinkedField',
          name: '__crewPoolProfilesList_crewPoolProfiles_connection',
          plural: false,
          selections: [
            v8 /*: any*/,
            {
              alias: null,
              args: null,
              concreteType: 'ProfileEdge',
              kind: 'LinkedField',
              name: 'edges',
              plural: true,
              selections: [
                {
                  alias: null,
                  args: null,
                  concreteType: 'Profile',
                  kind: 'LinkedField',
                  name: 'node',
                  plural: false,
                  selections: [
                    v9 /*: any*/,
                    {
                      alias: null,
                      args: null,
                      concreteType: 'GeneralSetting',
                      kind: 'LinkedField',
                      name: 'generalSetting',
                      plural: false,
                      selections: [v10 /*: any*/],
                      storageKey: null,
                    },
                    {
                      alias: null,
                      args: null,
                      concreteType: 'ProfileInfo',
                      kind: 'LinkedField',
                      name: 'info',
                      plural: false,
                      selections: [
                        v9 /*: any*/,
                        v12 /*: any*/,
                        v13 /*: any*/,
                        v14 /*: any*/,
                        v15 /*: any*/,
                        {
                          alias: null,
                          args: null,
                          concreteType: 'Country',
                          kind: 'LinkedField',
                          name: 'country',
                          plural: false,
                          selections: [v16 /*: any*/],
                          storageKey: null,
                        },
                        v17 /*: any*/,
                      ],
                      storageKey: null,
                    },
                    {
                      alias: null,
                      args: null,
                      concreteType: 'CertificateInfo',
                      kind: 'LinkedField',
                      name: 'certificateInfos',
                      plural: true,
                      selections: [v18 /*: any*/],
                      storageKey: null,
                    },
                    v19 /*: any*/,
                    v20 /*: any*/,
                  ],
                  storageKey: null,
                },
                v21 /*: any*/,
              ],
              storageKey: null,
            },
            v22 /*: any*/,
          ],
          storageKey: null,
        },
      ],
      type: 'Query',
      abstractKey: null,
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: [v5 /*: any*/, v0 /*: any*/, v2 /*: any*/, v1 /*: any*/, v3 /*: any*/, v4 /*: any*/],
      kind: 'Operation',
      name: 'ProfileQueriesGetProfileCrewPoolProfilesQuery',
      selections: [
        {
          alias: null,
          args: v23 /*: any*/,
          concreteType: 'ProfileConnection',
          kind: 'LinkedField',
          name: 'crewPoolProfiles',
          plural: false,
          selections: [
            v8 /*: any*/,
            {
              alias: null,
              args: null,
              concreteType: 'ProfileEdge',
              kind: 'LinkedField',
              name: 'edges',
              plural: true,
              selections: [
                {
                  alias: null,
                  args: null,
                  concreteType: 'Profile',
                  kind: 'LinkedField',
                  name: 'node',
                  plural: false,
                  selections: [
                    v9 /*: any*/,
                    {
                      alias: null,
                      args: null,
                      concreteType: 'GeneralSetting',
                      kind: 'LinkedField',
                      name: 'generalSetting',
                      plural: false,
                      selections: [v10 /*: any*/, v9 /*: any*/],
                      storageKey: null,
                    },
                    {
                      alias: null,
                      args: null,
                      concreteType: 'ProfileInfo',
                      kind: 'LinkedField',
                      name: 'info',
                      plural: false,
                      selections: [
                        v9 /*: any*/,
                        v12 /*: any*/,
                        v13 /*: any*/,
                        v14 /*: any*/,
                        v15 /*: any*/,
                        {
                          alias: null,
                          args: null,
                          concreteType: 'Country',
                          kind: 'LinkedField',
                          name: 'country',
                          plural: false,
                          selections: [v16 /*: any*/, v9 /*: any*/],
                          storageKey: null,
                        },
                        v17 /*: any*/,
                      ],
                      storageKey: null,
                    },
                    {
                      alias: null,
                      args: null,
                      concreteType: 'CertificateInfo',
                      kind: 'LinkedField',
                      name: 'certificateInfos',
                      plural: true,
                      selections: [v18 /*: any*/, v9 /*: any*/],
                      storageKey: null,
                    },
                    v19 /*: any*/,
                    v20 /*: any*/,
                  ],
                  storageKey: null,
                },
                v21 /*: any*/,
              ],
              storageKey: null,
            },
            v22 /*: any*/,
          ],
          storageKey: null,
        },
        {
          alias: null,
          args: v23 /*: any*/,
          filters: ['poolId', 'orderBy'],
          handle: 'connection',
          key: 'crewPoolProfilesList_crewPoolProfiles',
          kind: 'LinkedHandle',
          name: 'crewPoolProfiles',
        },
      ],
    },
    params: {
      cacheID: '97f7c8e59d079f7d7c2b6d4ceed6dfbd',
      id: null,
      metadata: {
        connection: [
          {
            count: null,
            cursor: null,
            direction: 'bidirectional',
            path: ['crewPoolProfiles'],
          },
        ],
      },
      name: 'ProfileQueriesGetProfileCrewPoolProfilesQuery',
      operationKind: 'query',
      text: 'query ProfileQueriesGetProfileCrewPoolProfilesQuery(\n  $poolId: ID!\n  $after: Cursor\n  $first: Int\n  $before: Cursor\n  $last: Int\n  $orderBy: ProfileOrder\n) {\n  crewPoolProfiles(poolId: $poolId, before: $before, first: $first, last: $last, after: $after, orderBy: $orderBy) {\n    totalCount\n    edges {\n      node {\n        id\n        generalSetting {\n          availableForWork\n          id\n        }\n        info {\n          id\n          primaryDuty {\n            id\n          }\n          firstName\n          lastName\n          birthDate\n          country {\n            isoCode\n            id\n          }\n          avatarUrl\n        }\n        certificateInfos {\n          certificate {\n            id\n          }\n          id\n        }\n        seaServices {\n          id\n          start\n          end\n          duty {\n            id\n          }\n          activities {\n            id\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n      hasPreviousPage\n      startCursor\n    }\n  }\n}\n',
    },
  };
})();

(node as any).hash = 'e64e4cf3467ebb35e8f5ea516082c885';

export default node;
